import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryUserTreeList } from '@/api/api';
import { getAction, httpAction } from '@api/manage';
import { accSubtr } from '@/utils/util.js';
import pick from 'lodash.pick';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'CarUseModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '车辆使用表单',
      tableName: 'ea_asset_car_use',
      form_fields: ['carId', 'userId', 'purpose', 'skm', 'ekm', 'total', 'roadFee', 'oilFee', 'status', 'sort', 'remark'],
      form_fields_time: ['sdate', 'edate'],
      validatorRules: {
        carId: {
          rules: [{
            required: true,
            message: '请输入车辆牌号!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择主要借用人!'
          }]
        },
        purpose: {
          rules: [{
            required: true,
            message: '请输入借车用途!'
          }]
        },
        sdate: {
          rules: [{
            required: true,
            message: '请选择借用时间!'
          }]
        }
      },
      url: {
        queryCarCards: '/ea/asset/car/queryCarCards'
      },
      loginUser: '',
      carCardsList: [],
      userTree: [],
      //人员信息
      carId: '',
      disableStatus: false
    };
  },
  props: {
    permissionObj: {
      type: Object,
      default: function _default() {
        edit: '';
      }
    },
    pagePath: String
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
  },
  methods: {
    moment: moment,
    add: function add(carId) {
      this.carId = carId;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.disableStatus = false;

      if (this.model.id == null) {
        this.model.userId = this.loginUser;
        this.model.sdate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');

        if (this.carId != null) {
          this.model.carId = parseInt(this.carId);
          this.disableStatus = true;
        }

        console.log('record', this.model.sdate._d);
      } else {
        this.model.edate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }

      this.loadCarCard();
      this.loadTreeList();
      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); // that.form.setFieldsValue({ sdate: this.model.sdate ? moment(this.model.sdate) : null })
        // that.form.setFieldsValue({ edate: this.model.edate ? moment(this.model.edate) : null })
        //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);
        console.log('setFieldsValue', that.form.setFieldsValue(timeVal));

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData.sdate = formData.sdate ? formData.sdate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.edate = formData.edate ? formData.edate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';
          var headers = {
            tableName: _this2.permissionObj.edit.split(':')[1]
          };

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';

            if (_this2.permissionObj.edit) {
              headers.id = _this2.model.id; // let largePermission = getLargePermission({ value: that.permissionObj.edit })
              // getBindingValue(headers, largePermission)
            }
          }

          httpAction(httpurl, formData, method, headers).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });

              _this2.$refs.iwupload.resetUploadFiles();

              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    loadCarCard: function loadCarCard() {
      var that = this;
      that.carCardsList = [];
      getAction(this.url.queryCarCards).then(function (res) {
        if (res.success) {
          that.carCardsList = res.result;
        }
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this3 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this3.loading = false;
        }
      });
    },
    total: function total() {
      var skm = this.form.getFieldValue('skm');
      var ekm = this.form.getFieldValue('ekm');

      if (skm >= ekm) {
        this.$message.error('初始里程不能为空或大等于于归还里程');
      } else if (ekm != null) {
        this.form.setFieldsValue(_defineProperty({}, 'total', accSubtr(ekm, skm)));
      }
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};